


   const isLocalhost =
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1";

        const logoutRedUri = isLocalhost
        ? "http://localhost:3000/login"
        : window._env_.REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI;

        const loginRedUri = isLocalhost
        ? "http://localhost:3000/callback"
        : window._env_.REACT_APP_OIDC_REDIRECT_URI;








const hasWindowEnv = typeof window !== 'undefined' &&
                     window._env_ &&
                     Object.keys(window._env_).length > 0;
const source = hasWindowEnv ? window._env_ : process.env;


const authority =source.REACT_APP_OIDC_AUTHORITY;
const clientId =source.REACT_APP_OIDC_CLIENT_ID;
const cogDomain =source.REACT_APP_OIDC_COGNITO_DOMAIN;

  export default {
          generalConf:{
            authority:  authority,
            client_id: clientId,
            redirect_uri: loginRedUri,
            post_logout_redirect_uri: logoutRedUri,
            response_type: "code",
            scope: "email openid profile",
            onSigninCallback: () => {
            // optional: clean up query params
            window.history.replaceState({}, document.title, '/');
            },
          },
          cogDomain: cogDomain


};












  







  